<template>
  <b-row>
    <b-col cols="8">
      <BfInput
        label="Nombre"
        data-key="nombre"
        :value="data.nombre"
        :edit-mode="editing"
        :errors="errors"
        @update="updateForm"
      />
    </b-col>
    <b-col cols="4">
      <BfInput
        label="Empresa"
        data-key="nombre_empresa"
        :value="data.nombre_empresa"
        :edit-mode="editing"
        :errors="errors"
        @update="updateForm"
      />
    </b-col>
    <b-col cols="8">
      <BfInput
        label="Dirección"
        data-key="direccion"
        :value="data.direccion"
        :edit-mode="editing"
        :errors="errors"
        @update="updateForm"
      />
    </b-col>
    <b-col cols="4">
      <BfInput
        label="Código Postal"
        data-key="codigopostal"
        :value="data.codigopostal"
        :edit-mode="editing"
        :errors="errors"
        @update="updateCp"
      />
    </b-col>
    <b-col cols="4">
      <BfInput
        label="Población"
        data-key="poblacion"
        :value="data.poblacion"
        :edit-mode="editing"
        :errors="errors"
        @update="updateForm"
        readonly
      />
    </b-col>
    <b-col cols="4">
      <BfInput
        label="Provincia"
        data-key="provincia"
        :value="data.provincia"
        :edit-mode="editing"
        :errors="errors"
        @update="updateForm"
        readonly
      />
    </b-col>
    <b-col cols="8">
      <BfInput
        label="Email"
        data-key="email"
        :value="data.email"
        :edit-mode="editing"
        :errors="errors"
        @update="updateForm"
      />
    </b-col>
    <b-col cols="4">
      <BfInput
        label="Teléfono"
        data-key="telefono1"
        :value="data.telefono1"
        :edit-mode="editing"
        :errors="errors"
        @update="updateForm"
      />
    </b-col>
    <b-col cols="8">
      <BfInput
        label="Fax"
        data-key="key"
        :value="data.fax"
        :edit-mode="editing"
        :errors="errors"
        @update="updateForm"
      />
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'DelegationForm',

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },

    editing: {
      type: Boolean,
      default: false,
    },

    errors: {
      type: Object,
    },
  },

  methods: {
    updateForm(fieldData) {
      this.$emit('update', fieldData);
    },
    updateCp(fieldData) {
      this.$emit('updatecp', fieldData);
    },
  },
};
</script>
